import { NgModule } from "@angular/core";

import { LoginModule } from "@bitwarden/web-vault/app/gloss/login/login.module";
import { TrialInitiationModule } from "@bitwarden/web-vault/app/gloss/others/trial-initiation/trial-initiation.module";
import { LooseComponentsModule, SharedModule } from "./shared";

@NgModule({
  imports: [SharedModule, LooseComponentsModule, TrialInitiationModule, LoginModule],
  exports: [SharedModule, LooseComponentsModule, TrialInitiationModule, LoginModule],
  bootstrap: [],
})
export class OssModule {}
